import { Stack, Typography } from '@mui/material';
import AddNewQuestionIcon from 'Components/Icons/AddNewQuestionIcon';
import UploadIcon from 'Components/Icons/UploadIcon';
import React, { useState } from 'react';

import { UPGRADE_PREMIUM, checkIsFreemiumPlan } from 'helper/checkPlan.helper';
import { SET_MODAL_STATUS, SET_MODAL_TYPE } from 'store/actions';
import { ACTION_BUTTON_TYPES } from './constants';
import { setModalOpen, setModalType } from 'store/ResponseTemplate/actions';
import { useDispatch, useSelector } from 'react-redux';

const ImportQuestionCSVCard = () => {
    const dispatch = useDispatch();
    const [type, setType] = useState('');
    // const { templateType, items } = useSelector((params) => params.response);
    const { companyData } = useSelector((params) => params.customization);

    const handleOnClick = () => {
        if (checkIsFreemiumPlan(companyData?.subscription?.plan)) {
            setType(ACTION_BUTTON_TYPES.IMPORT);
            dispatch({ type: SET_MODAL_STATUS, modalStatus: true });
            dispatch({ type: SET_MODAL_TYPE, modalType: UPGRADE_PREMIUM?.questionRegistry });
        } else {
            dispatch({ type: setModalOpen, modalOpen: true });
            dispatch({ type: setModalType, modalType: 'import-csv' });
        }
    };
    return (
        <Stack gap="10px" className="import-question-csv-card" alignItems="center" justifyContent="center" onClick={handleOnClick}>
            <Stack direction="row" alignItems="center" gap={1}>
                <UploadIcon />
                <Typography variant="subtitle1" component="h3" color="#00214D" fontSize="1rem" lineHeight="1.2" fontWeight="600">
                    Import questions via CSV
                </Typography>
            </Stack>
        </Stack>
    );
};

export default ImportQuestionCSVCard;
